import { useCountriesWithPlantsByProduct, useCountryProductSummary } from '@/domain/country/hooks';
import { type CountryBubbleData } from '@/features/country/components/CountryMap/types';
import { useMemo } from 'react';

const toLocation = (latitude: number | null, longitude: number | null): [number, number] => [
  latitude ?? 0,
  longitude ?? 0,
];

export const useProductCountriesMapData = (idProduct: number, isLoggedIn: boolean): CountryBubbleData[] => {
  const { data: detailedData } = useCountriesWithPlantsByProduct(idProduct, isLoggedIn);
  const { data: summaryData } = useCountryProductSummary(idProduct, !isLoggedIn);

  return useMemo((): CountryBubbleData[] => {
    if (isLoggedIn) {
      return (detailedData ?? []).map((country) => ({
        ...country,
        location: toLocation(country.latitude, country.longitude),
        count: country.plants.length,
      }));
    }

    return (summaryData ?? []).map((country) => ({
      ...country,
      plants: [],
      location: toLocation(country.latitude, country.longitude),
      count: country.plantCount,
    }));
  }, [detailedData, summaryData, isLoggedIn]);
};
